import React, { useState } from 'react'
import { Button } from 'antd'
import { useTranslation } from 'react-i18next'
import { Dimension } from '../../../../../features/dimension/types/Dimension'
import { useUndo } from '../../../../../features/dimension/queries/useUndo'
import { useUndoLatest } from '../../../../../features/dimension/queries/useUndoLatest'
import DimensionUndoConfirm from './DimensionUndoConfirm'

interface DimensionUndoButtonProps {
  canEdit: boolean
}

const DimensionUndoButton: React.FC<DimensionUndoButtonProps> = ({ canEdit }) => {
  const { t } = useTranslation()
  const { data: undoList = [] } = useUndo<Dimension>()
  const { mutateAsync: undoLatest, isPending } = useUndoLatest()
  const [open, setOpen] = useState(false)

  if (!canEdit || undoList.length === 0) return null

  const handleConfirm = async () => {
    await undoLatest()
    setOpen(false)
  }

  return (
    <>
      <Button onClick={() => setOpen(true)}>{t('dimensionsPage:undo-text')}</Button>
      <DimensionUndoConfirm
        open={open}
        undoEntry={undoList[0]}
        isUndoing={isPending}
        onConfirm={handleConfirm}
        onClose={() => setOpen(false)}
      />
    </>
  )
}

export default DimensionUndoButton
